<script setup lang="ts">
import { FairIcon } from '@/ui/primitives/FairIcon'
import { FAIR_TOAST_BOTTOM_OFFSET_PX } from '@/ui/tokens/fair-toast.data'
import { useFairToast } from './useFairToast'

const { toasts, dismiss } = useFairToast()

function handleLinkClick(id: number, onLinkClick?: () => void) {
  onLinkClick?.()
  dismiss(id)
}
</script>

<template>
  <Teleport to="body">
    <div
      class="fair-toast-host"
      :style="{ '--fair-toast-bottom': `${FAIR_TOAST_BOTTOM_OFFSET_PX}px` }"
      aria-live="polite"
      aria-relevant="additions"
    >
      <TransitionGroup name="fair-toast">
        <div
          v-for="item in toasts"
          :key="item.id"
          class="fair-toast"
          role="status"
        >
          <FairIcon
            v-if="item.showIcon"
            class="fair-toast__icon"
            name="check"
            :size="24"
          />
          <p class="fair-toast__text">
            <span>{{ item.message }}</span>
            <template v-if="item.linkLabel">
              <button
                type="button"
                class="fair-toast__link"
                @click="handleLinkClick(item.id, item.onLinkClick)"
              >
                {{ item.linkLabel }}
              </button>
            </template>
          </p>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>
